module.exports = __webpack_public_path__ + "static/img/fuwu.6817cf39.png";